export default function () {
  $(document).on('click', '[data-pjax] [type="submit"]', function(event) {
    $("<input type='hidden' name='submit' value='submit' />").appendTo($(this).closest('form'));
  });
}
